import api, { apiSetup } from '../api';

apiSetup();

export class AlcancesService {
  BASE_URL = '/alcances';

  get() {
    return api.get(this.BASE_URL);
  }
}
